import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Service} from "../../models/service.model";

@Injectable({providedIn: 'root'})
export class ServicesHttpService {

  private base_url = `/services`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getService(serviceId: string): Observable<Service> {
    return this.http.get<Service>(`${this.base_url}/${serviceId}`);
  }

  getServices(params?: any): Observable<{ list: Service[], cursor?: string }> {
    return this.http
      .get<{ list: Service[], cursor?: string }>(this.base_url, {params});
  }

}
